import gql from 'graphql-tag';

const GET_LANDLORD_INFORMATION_QUERY = gql`
  query LandlordInformation($landlordId: ID!) {
    landlordInformation(landlordId: $landlordId) {
      firstListingDate
      listingsPublished
      type
      averageResponseTime
      numberOfBookingRequests
      languages
      yearsWithUs
      monthsWithUs
    }
  }
`;

export const getLandlordInformationQuery = client => landlordId =>
  client.query({
    query: GET_LANDLORD_INFORMATION_QUERY,
    fetchPolicy: 'cache-first',
    variables: {
      landlordId
    }
  });

export default getLandlordInformationQuery;
